const analyticEventTracker = {
    reservedAttributes: ['eventName'],
    analyticsEventInProgress: false,
    init: function() {
        $(document).on('click', '.trigger-event', function() {
            const that = $(this);
            const dataAttributes = (typeof that.data() !== 'undefined' ? that.data() : false);
            const postData = {
                eventName: (typeof that.data('event-name') !== 'undefined' ? that.data('event-name') : 'Unknown')
            };

            if (dataAttributes) {
                const attributes = analyticEventTracker.collectAttributes(dataAttributes);

                if (Object.keys(attributes).length > 0) {
                    postData['attributes'] = attributes;
                }
            }

            if (!analyticEventTracker.analyticEventInProgress) {
                analyticEventTracker.analyticEventInProgress = true;
                analyticEventTracker.trackEvent(postData);

                setTimeout(function() {
                    analyticEventTracker.analyticEventInProgress = false;
                }, 1000);
            }
        });
    },
    collectAttributes: function(dataAttributes, isError = false) {
        let attributes = {};

        if (isError) {
            dataAttributes.forEach(item => {
                if (item && typeof item === 'object' && item.name && item.value) {
                    const newValue = item.value.replace('-error', '');

                    const key = `${item.name.replace('aria-describedby', `attribute${newValue.charAt(0).toUpperCase() + newValue.slice(1)}Error`)}`;
                    dataAttributes[key] = item.value;
                }
            });
        }

        for (let x in dataAttributes) {
            if (Object.prototype.hasOwnProperty.call(dataAttributes, x)) {
                if (!analyticEventTracker.reservedAttributes.includes(x)) {
                    attributes[x] = dataAttributes[x];
                }
            }
        }

        return attributes;
    },
    sendInstantEvent: function(eventName, dataAttributes = null) {
        const postData = {
            eventName: eventName
        };

        if (dataAttributes) {
            const attributes = analyticEventTracker.collectAttributes(dataAttributes);

            if (Object.keys(attributes).length > 0) {
                postData['attributes'] = attributes;
            }
        }

        analyticEventTracker.trackEvent(postData);
    },
    trackEvent: function(postData) {
        $.ajax({
            url: _d.url.analyticEvent,
            type: 'POST',
            data: postData
        });
    }
};
